<app-modal #modal>
  <div class="modal-content">
    <div class="modal-header">
      <h2 class="modal-title">Confirm</h2>
    </div>
    <div class="modal-body">
      <p>Please confirm that you want to continue to assign and move this wallet.</p>
      <p>Once you select 'Confirm', you will not be able to reverse the action.</p>
    </div>
    <div class="modal-footer">
      <div class="row">
        <div class="col-6">
          <a (click)="onConfirmWalletAssignment()" class="btn btn-primary"
            [ngClass]="{'disabled': isAssignmentProcessing || moveAndAssignFailure}">
            <span *ngIf="isAssignmentProcessing">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            </span>
            <span *ngIf="!isAssignmentProcessing">{{ moveAndAssignButtonText}} </span>
          </a>
        </div>
        <div class="col-6">
          <a (click)="modal.hide()" class="btn btn-secondary" data-dismiss="modal">Cancel</a>
        </div>
      </div>
    </div>
  </div>
</app-modal>